import { makeAutoObservable, runInAction } from "mobx";
import { validate } from "./valid";
import i18n from "i18next";
import MainStore from "MainStore";
import { getOrganization, updateOrganization, createOrganization} from "api/Organisation/index";


class NewStore {
  id = 0;
  organization_code = "";
  name = "";
  short_name = "";
  organization_type = "";
  inn = "";
  address = "";
  phone = "";
  email = "";
  is_active = true;
  
  errororganization_code = "";
  errorname = "";
  errorshort_name = "";
  errororganization_type = "";
  errorinn = "";
  erroraddress = "";
  errorphone = "";
  erroremail = "";

  constructor() {
    makeAutoObservable(this);
  }

  clearStore() {
    runInAction(() => {
      this.id = 0;
      this.organization_code = "";
      this.name = "";
      this.short_name = "";
      this.organization_type = "";
      this.inn = "";
      this.address = "";
      this.phone = "";
      this.email = "";
      this.is_active = true;
      this.errororganization_code = "";
      this.errorname = "";
      this.errorshort_name = "";
      this.errororganization_type = "";
      this.errorinn = "";
      this.erroraddress = "";
      this.errorphone = "";
      this.erroremail = "";
    });
  }

  handleChange(event) {
    this[event.target.name] = event.target.value;
    validate(event);
  }

  onSaveClick = async (onSaved: (id: number) => void) => {
    let canSave = true;
    
    // Валидация обязательных полей
    let event: { target: { name: string; value: any } } = {
      target: { name: "id", value: this.id }
    };
    canSave = validate(event) && canSave;
    
    event = { target: { name: "organization_code", value: this.organization_code } };
    canSave = validate(event) && canSave;
    
    event = { target: { name: "name", value: this.name } };
    canSave = validate(event) && canSave;
    
    event = { target: { name: "organization_type", value: this.organization_type } };
    canSave = validate(event) && canSave;
    
    event = { target: { name: "inn", value: this.inn } };
    canSave = validate(event) && canSave;
    
    // Валидация email если заполнен
    if (this.email && this.email.trim() !== "") {
      event = { target: { name: "email", value: this.email } };
      canSave = validate(event) && canSave;
    }

    if (canSave) {
      try {
        MainStore.changeLoader(true);
        var data = {
          id: this.id,
          organization_code: this.organization_code,
          name: this.name,
          short_name: this.short_name,
          organization_type: this.organization_type,
          inn: this.inn,
          address: this.address,
          phone: this.phone,
          email: this.email,
          is_active: this.is_active
        };

        const response = data.id === 0
          ? await createOrganization(data)
          : await updateOrganization(data);

        if (response.status === 201 || response.status === 200) {
          onSaved(response.data.id);
          console.log(i18n.language);
          if (data.id === 0) {
            this.id = response.data.id;
            MainStore.setSnackbar(i18n.t("message:snackbar.successSave"), "success");
          } else {
            MainStore.setSnackbar(i18n.t("message:snackbar.successEdit"), "success");
          }
        } else {
          throw new Error();
        }
      } catch (err) {
        MainStore.setSnackbar(i18n.t("message:somethingWentWrong"), "error");
      } finally {
        MainStore.changeLoader(false);
      }
    } else {
      MainStore.openErrorDialog(i18n.t("message:error.alertMessageAlert"));
    }
  };

  loadOrganization = async (id: number) => {
    try {
      MainStore.changeLoader(true);
      const response = await getOrganization(id);
      if ((response.status === 201 || response.status === 200) && response?.data !== null) {
        runInAction(() => {
          this.organization_code = response.data.organization_code;
          this.name = response.data.name;
          this.short_name = response.data.short_name;
          this.organization_type = response.data.organization_type;
          this.inn = response.data.inn;
          this.address = response.data.address;
          this.phone = response.data.phone;
          this.email = response.data.email;
          this.is_active = response.data.is_active;
        });
      } else {
        throw new Error();
      }
    } catch (err) {
      MainStore.setSnackbar(i18n.t("message:somethingWentWrong"), "error");
    } finally {
      MainStore.changeLoader(false);
    }
  };

  async doLoad(id: number) {
    if (id == null || id == 0) {
      return;
    }
    this.id = id;
    this.loadOrganization(id);
  }
}

export default new NewStore();